// Chat page top bar: temporary/sensitive badges + primary session actions.
import React from 'react';

export interface ChatTopBarProps {
  onNewChat: () => void;
  onNewTempChat: () => void;
  onExport: () => void;
  isTemporary?: boolean;
  isSensitive?: boolean;
}

export default function ChatTopBar({
  onNewChat,
  onNewTempChat,
  onExport,
  isTemporary,
  isSensitive,
}: ChatTopBarProps) {
  return (
    <div className="malpedia-chat-topbar">
      {(isTemporary || isSensitive) && (
        <div className="malpedia-chat-topbar-flags">
          {isTemporary && (
            <span
              className="malpedia-chat-flag-toggle is-on"
              title="Temporary mode: nothing stored on the server"
            >
              👻 Temporary
            </span>
          )}
          {isSensitive && (
            <span
              className="malpedia-chat-header-sensitive"
              title="Marked sensitive — excluded from any future cross-user features"
              aria-label="Sensitive"
            >
              Sensitive
            </span>
          )}
        </div>
      )}

      <div className="malpedia-chat-topbar-actions">
        <button className="malpedia-chat-topbar-new-btn" onClick={onNewChat}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="7" y1="2" x2="7" y2="12" />
            <line x1="2" y1="7" x2="12" y2="7" />
          </svg>
          New Chat
        </button>
        <button
          className="malpedia-chat-topbar-temp-btn"
          onClick={onNewTempChat}
          aria-label="Temporary chat"
          title="Temporary chat (not saved to history)"
        >
          <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="8" cy="8" r="6.5" />
            <polyline points="8 4.5 8 8 10.5 9.5" />
          </svg>
        </button>
        <button
          className="malpedia-chat-topbar-export-btn"
          onClick={onExport}
          aria-label="Export chats"
          title="Export chats"
        >
          <svg width="15" height="15" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 2v8M4 7l3 3 3-3" />
            <path d="M2.5 11.5h9" />
          </svg>
        </button>
      </div>
    </div>
  );
}
